

jQuery(document).ready(function($) {
$('h4:empty').append("<span style='display:none'> . </span> ");
 $('h3:has(b:empty)').append("<span style='display:none'> . </span> ");
console.log( "ready!" );

   try{
    Intervaltime3 =setInterval(GenerateAriaLabelForPopup, 500);
 
      
    }
    catch(err)
    {
    }
    function GenerateAriaLabelForPopup()
    {
       if($(".jdgm-random-link").length)
      {
       $(".jdgm-random-link").attr("aria-label","random link");
       clearInterval(Intervaltime3);
         console.log("iframe found");
      }
    }


});


!function(){function e(){var e=((new Date).getTime(),document.createElement("script"));e.type="text/javascript",e.async=!0,e.setAttribute("embed-id","9a73350b-45bb-4f26-b5fc-1a7e4243102d"),e.src="https://embed.adabundle.com/embed-scripts/9a73350b-45bb-4f26-b5fc-1a7e4243102d",window.top.document.getElementsByTagName("body")[0].appendChild(e)}var t=window;t.attachEvent?t.attachEvent("onload",e):t.addEventListener("load",e,!1)}();